import _ from 'lodash';
import { atom } from 'jotai';
import { initAppDb , regEvent , regEffect , dispatch , regSub , current, useSubscription } from '@flexsurfer/reflex';
import { enableTracing, enableTracePrint } from '@flexsurfer/reflex';
import {
  validateOverview,
  validateImagery,
  validatePlots,
  validateSamples,
  validateQuestions,
  validateWizard,
  validateStep,
} from "../wizard/validation";

export const previewSelectedSampleIdAtom = atom(1);
export const previewUserSamplesAtom = atom({});
if (process.env.NODE_ENV !== 'production') { enableTracing(); enableTracePrint(); }  

const newRuleDefaults = {
  'rules.newRule.label': null,
  'rules.newRule.regex': "",
  'rules.newRule.questionId': -1,
  'rules.newRule.min': 0,
  'rules.newRule.max': 0,
  'rules.newRule.validSum': 0,
  'rules.newRule.questionIds': [],
  'rules.newRule.questionIds1': [],
  'rules.newRule.questionIds2': [],
  'rules.newRule.questionId1': -1,
  'rules.newRule.questionId2': -1,
  'rules.newRule.incompatQuestionId': -1,
  'rules.newRule.incompatAnswerId': -1,
  'rules.newRule.tempQuestionId': -1,
  'rules.newRule.tempAnswerId': -1,
  'rules.newRule.answerId1': -1,
  'rules.newRule.answerId2': -1,
  'rules.newRule.answers': [],
};

const projectWizardDb = {
  institutionId: -1,
  errors: [],
  currentStep: null,
  modal: null,
  projectSource: null,
  projectId: -1,
  projectDraftId: -1,
  draftSaving: false,
  projectSaving: false,
  templateProjectId: -1,
  templateProjectName: '',
  useTemplatePlots: false,
  templatePlotDesign: null,
  useTemplateWidgets: false,
  originalProject: {},
  invalidSteps: [],
  availability: '',
  publishedDate: '',
  createdDate: '',
  closedDate: '',
  // overview
  'overview.projectName': '',
  'overview.projectDescription': '',
  'overview.projectType': 'regular',
  'overview.learningMaterial': '',
  'overview.visibility': 'institution',
  // overview.projectOptions
  'overview.projectOptions.showGEEScript': false,
  'overview.projectOptions.showPlotInformation': false,
  'overview.projectOptions.collectConfidence': false,
  'overview.projectOptions.autoLaunchGeoDash': true,
  'overview.projectOptions.plotSimilarity': false,
  'overview.projectOptions.license': null,
  'overview.useTemplatePlots': false,
  'overview.useTemplateWidgets': false,
  'imagery.imageryList': [],
  'imagery.previewId': '',
  'institutionImagery': [],
  // boundary
  'boundary.generationMethod': 'manual',
  'boundary.aoiFeatures': [],
  'boundary.aoiFileName': '',
  // plots
  'plots.plotDistribution': 'random',
  'plots.numPlots': '',
  'plots.plotSize': '',
  'plots.plotShape': 'circle',
  'plots.plotSpacing': null,
  'plots.shufflePlots': false,
  'plots.plotsSource': null,
  'plots.totalPlots': 0,
  'plots.plotFeatures': [],
  'plots.plotFileName': '',
  'plots.plotFileBase64': null,
  'plots.plotIds': [],
  'plots.referencePlotId': -1,
  'plots.similariyYears': null,
  'plots.designSettings': {
    sampleGeometries: {
      points:   true,
      lines:    true,
      polygons: true},
    userAssignment: {
      userMethod:  "none",
      users:       [],
      percents:    []},
    qaqcAssignment: {
      qaqcMethod:    "none",
      percent:       0,
      smes:          [],
      timesToReview: 2}},
  'plots.plotSimilarityDetails': { referencePlotId: "", years: [] },
  'plots.newPlotDistribution': 'csv',
  'plots.newPlotSize': '',
  'plots.newPlotShape': 'circle',
  'plots.newTotalPlots': 0,
  'plots.newPlotFeatures': [],
  'plots.newPlotFileName': '',
  'plots.newPlotFileBase64': null,
  'plots.maxId': null,
  // samples
  'samples.sampleDistribution': 'random',
  'samples.samplesPerPlot': 1,
  'samples.sampleResolution': 0,
  'samples.sampleFileName': '',
  'samples.sampleFeautres': [],
  'samples.allowDrawnSamples': false,
  'samples.sampleFileBase64': null,
  'questions': {},
  'rules': [],
  'rules.search': null,
  'rules.filter': null,
  'rules.selectedRuleType': null,
  ...newRuleDefaults,
  'institution.users': []
};

initAppDb(projectWizardDb);

export const event_ids = {
  institutionId: 'institutionId',
  projectId: 'projectId',
  draftProject: 'draftProject',
  editProject: 'editProject',
  submitForm: 'submitForm',
  saveDraft: 'saveDraft',
  saveProject: 'saveProject',
  publishProject: 'publishProject',
  templateProjectId: 'templateProjectId',
  templateProjectName: '',
  templatePlotDesign: 'templatePlotDesign',
  templateProject: 'templateProject',
  importProject: 'importProject',
  errors: 'errors',
  continueHandler: 'continueHandler',
  validate: 'validate',
  currentStep: 'currentStep',
  modal: 'modal',
  availability: 'availability',
  projectSource: 'projectSource',
  successResponse: 'successReponse',
  draftSuccess:'draftSuccess',
  draftSaving: 'draftSaving',
  projectSaving: 'projectSaving',
  overview: {projectName: 'overview.projectName',
    projectDescription: 'overview.projectDescription',
    projectType: 'overview.projectType',
    learningMaterial: 'overview.learningMaterial',
    visibility: 'overview.visibility',
    useTemplatePlots: 'overview.useTemplatePlots',
    useTemplateWidgets: 'overview.useTemplateWidgets',
    projectOptions: {
      showGEEScript: 'overview.projectOptions.showGEEScript',
      showPlotInformation: 'overview.projectOptions.showPlotInformation',
      collectConfidence: 'overview.projectOptions.collectConfidence',
      autoLaunchGeoDash: 'overview.projectOptions.autoLaunchGeoDash',
      plotSimilarity: 'overview.projectOptions.plotSimilarity',
      license: 'overview.projectOptions.license',
    }},
  projectDetails: 'projectDetails',
  imagery: {
    imageryList: 'imagery.imageryList',
    previewId: 'imagery.previewId'
  },
  boundary: {
    generationMethod: 'boundary.generationMethod',
    aoiFeatures: 'boundary.aoiFeatures',
    aoiFileName: 'boundary.aoiFileName',
    clearBoundary: 'boundary.clearBoundary',
    setBoundaryFromFile: 'boundary.setBoundaryFromFile'
  },
  plots: {
    plots: 'plots.plots',
    plotDistribution: 'plots.plotDistribution',
    numPlots: 'plots.numPlots',
    plotSize: 'plots.plotSize',
    plotShape: 'plots.plotShape',
    plotSpacing: 'plots.plotSpacing',
    shufflePlots: 'plots.shufflePlots',
    totalPlots: 'plots.totalPlots',
    plotFeatures: 'plots.plotFeatures',
    plotFileName: 'plots.plotFileName',
    plotFileBase64: 'plots.plotFileBase64',
    plotIds: 'plots.plotIds',
    designSettings: 'plots.designSettings',
    plotSimilarityDetails: 'plots.plotSimilarityDetails',
    plotsSource: 'plots.plotsSource',
    serverPlots: 'plots.serverPlots',
    newPlotDistribution: 'plots.newPlotDistribution',
    newPlotSize: 'plots.newPlotSize',
    newPlotShape: 'plots.newPlotShape',
    newTotalPlots: 'plots.newTotalPlots',
    newPlotFeatures: 'plots.newPlotFeatures',
    newPlotFileName: 'plots.newPlotFileName',
    newPlotFileBase64: 'plots.newPlotFileBase64',
  },
  samples: {
    sampleDistribution: 'samples.sampleDistribution',
    samplesPerPlot: 'samples.samplesPerPlot',
    sampleResolution: 'samples.sampleResolution',
    sampleFileName: 'samples.sampleFileName',
    sampleFileBase64: 'samples.sampleFileBase64',
    allowDrawnSamples: 'samples.allowDrawnSamples'
  },
  questions: {
    addQuestion: 'addQuestion',
    setQuestions: 'setQuestions',
    updateQuestion: 'updateQuestion',
    updateAnswer: 'updateAnswer',
    moveQuestion: 'moveQuestion',
    removeQuestion: 'removeQuestion',
  },
  rules: {
    rules: 'rules',
    removeRule: 'rules.removeRule',
    search: 'rules.search',
    filter: 'rules.filter',
    selectedRuleType: 'rules.selectedRuleType',
    newRule: {
      reset: 'rules.newRule.reset',
      label: 'rules.newRule.label',
      answers: 'rules.newRule.answers',
      addAnswer: 'rules.newRule.addAnswer',
      removeAnswer: 'rules.newRule.removeAnswer',
      regex: 'rules.newRule.regex',
      questionId: 'rules.newRule.questionId',
      min: 'rules.newRule.min',
      max: 'rules.newRule.max',
      validSum: 'rules.newRule.validSum',
      questionIds: 'rules.newRule.questionIds',
      questionIds1: 'rules.newRule.questionIds1',
      questionIds2: 'rules.newRule.questionIds2',
      questionId1: 'rules.newRule.questionId1',
      questionId2: 'rules.newRule.questionId2',
      answerId1: 'rules.newRule.answerId1',
      answerId2: 'rules.newRule.answerId2',
      tempQuestionId: 'rules.newRule.tempQuestionId',
      tempAnswerId: 'rules.newRule.tempAnswerId',
      incompatQuestionId: 'rules.newRule.incompatQuestionId',
      incompatAnswerId: 'rules.newRule.incompatAnswerId',
    }},
  institution: {
    users: 'institution.users',
    imagery: 'institutionImagery'}};

export const sub_ids = {
  institutionId: 'institutionId',
  errors: 'errors',
  projectId : 'projectId',
  projectDraftId: 'projectDraftId',
  draftSaving: 'draftSaving',
  projectSaving: 'projectSaving',
  currentStep: 'currentStep',
  modal: 'modal',
  projectSource: 'projectSource',
  successResponse: 'successReponse',
  templateProjectId: 'templateProjectId',
  templateProjectName: '',
  templatePlotDesign: 'templatePlotDesign',
  originalProject: 'originalProject',
  validStep: 'validStep',
  invalidSteps: 'invalidSteps',
  availability: 'availability',
  publishedDate: 'publishedDate',
  createdDate: 'createdDate',
  closedDate: 'closedDate',
  overview: {projectName: 'overview.projectName',
    projectDescription: 'overview.projectDescription',
    projectType: 'overview.projectType',
    learningMaterial: 'overview.learningMaterial',
    visibility: 'overview.visibility',
    useTemplatePlots: 'overview.useTemplatePlots',
    useTemplateWidgets: 'overview.useTemplateWidgets',
    projectOptions: {
      showGEEScript: 'overview.projectOptions.showGEEScript',
      showPlotInformation: 'overview.projectOptions.showPlotInformation',
      collectConfidence: 'overview.projectOptions.collectConfidence',
      autoLaunchGeoDash: 'overview.projectOptions.autoLaunchGeoDash',
      plotSimilarity: 'overview.projectOptions.plotSimilarity',
      license: 'overview.projectOptions.license',
    }},
  projectDetails: 'projectDetails',
  imagery: {
    imageryList: 'imagery.imageryList',
    previewId: 'imagery.previewId'},
  boundary: {
    generationMethod: 'boundary.generationMethod',
    aoiFeatures: 'boundary.aoiFeatures',
    aoiFileName: 'boundary.aoiFileName'
  },
  plots: {
    plots: 'plots.plots',
    plotDistribution: 'plots.plotDistribution',
    numPlots: 'plots.numPlots',
    plotSize: 'plots.plotSize',
    plotShape: 'plots.plotShape',
    plotSpacing: 'plots.plotSpacing',
    shufflePlots: 'plots.shufflePlots',
    totalPlots: 'plots.totalPlots',
    plotFeatures: 'plots.plotFeatures',
    plotFileName: 'plots.plotFileName',
    plotFileBase64: 'plots.plotFileBase64',
    plotIds: 'plots.plotIds',
    designSettings: 'plots.designSettings',
    plotSimilarityDetails: 'plots.plotSimilarityDetails',
    referencePlotId: 'plots.referencePlotId',
    plotsSource: 'plots.plotsSource',
    newPlotDistribution: 'plots.newPlotDistribution',
    newPlotSize: 'plots.newPlotSize',
    newPlotShape: 'plots.newPlotShape',
    newTotalPlots: 'plots.newTotalPlots',
    newPlotFeatures: 'plots.newPlotFeatures',
    newPlotFileName: 'plots.newPlotFileName',
    newPlotFileBase64: 'plots.newPlotFileBase64',
    maxId: 'plots.maxId',
  },
  samples: {
    sampleDistribution: 'samples.sampleDistribution',
    samplesPerPlot: 'samples.samplesPerPlot',
    sampleResolution: 'samples.sampleResolution',
    sampleFileName: 'samples.sampleFileName',
    sampleFileBase64: 'samples.sampleFileBase64',
    allowDrawnSamples: 'samples.allowDrawnSamples'
  },
  questions: {
    questions: 'questions'
  },
  rules: {rules: 'rules',
    search: 'rules.search',
    filter: 'rules.filter',
    selectedRuleType: 'rules.selectedRuleType',
    newRule: {
      label: 'rules.newRule.label',
      answers: 'rules.newRule.answers',
      regex: 'rules.newRule.regex',
      min: 'rules.newRule.min',
      max: 'rules.newRule.max',
      validSum: 'rules.newRule.validSum',
      questionId: 'rules.newRule.questionId',
      questionIds: 'rules.newRule.questionIds',
      questionIds1: 'rules.newRule.questionIds1',
      questionIds2: 'rules.newRule.questionIds2',
      questionId1: 'rules.newRule.questionId1',
      questionId2: 'rules.newRule.questionId2',
      answerId1: 'rules.newRule.answerId1',
      answerId2: 'rules.newRule.answerId2',
      tempQuestionId: 'rules.newRule.tempQuestionId',
      tempAnswerId: 'rules.newRule.tempAnswerId',
      incompatQuestionId: 'rules.newRule.incompatQuestionId',
      incompatAnswerId: 'rules.newRule.incompatAnswerId',
    }},
  institution: {
    imagery: 'institutionImagery',
    users: 'institution.users'}
};

export const effects = {};

regSub(sub_ids.projectId, sub_ids.projectId);
regSub(sub_ids.currentStep, sub_ids.currentStep);
regSub(sub_ids.modal, sub_ids.modal);
regSub(sub_ids.draftSaving, sub_ids.draftSaving);
regSub(sub_ids.projectSaving, sub_ids.projectSaving);
regSub(sub_ids.projectSource, sub_ids.projectSource);
regSub(sub_ids.errors, sub_ids.errors);
regSub(sub_ids.successResponse, sub_ids.successResponse);
regSub(sub_ids.institutionId, sub_ids.institutionId);
regSub(sub_ids.templateProjectId, sub_ids.templateProjectId);
regSub(sub_ids.templatePlotDesign, sub_ids.templatePlotDesign);
regSub(sub_ids.useTemplatePlots, sub_ids.useTemplatePlots);
regSub(sub_ids.useTemplateWidgets, sub_ids.useTemplateWidgets);
regSub(sub_ids.availability, sub_ids.availability);
regSub(sub_ids.publishedDate, sub_ids.publishedDate);
regSub(sub_ids.createdDate, sub_ids.createdDate);
regSub(sub_ids.closedDate, sub_ids.closedDate);

regSub(sub_ids.overview.projectType, sub_ids.overview.projectType);
regSub(sub_ids.overview.projectName, sub_ids.overview.projectName);
regSub(sub_ids.overview.projectDescription, sub_ids.overview.projectDescription);
regSub(sub_ids.overview.learningMaterial, sub_ids.overview.learningMaterial);
regSub(sub_ids.overview.visibility, sub_ids.overview.visibility);
regSub(sub_ids.overview.projectOptions.showGEEScript, sub_ids.overview.projectOptions.showGEEScript);
regSub(sub_ids.overview.projectOptions.showPlotInformation, sub_ids.overview.projectOptions.showPlotInformation);
regSub(sub_ids.overview.projectOptions.collectConfidence, sub_ids.overview.projectOptions.collectConfidence);
regSub(sub_ids.overview.projectOptions.autoLaunchGeoDash, sub_ids.overview.projectOptions.autoLaunchGeoDash);
regSub(sub_ids.overview.useTemplatePlots, sub_ids.overview.useTemplatePlots);
regSub(sub_ids.overview.useTemplateWidgets, sub_ids.overview.useTemplateWidgets);
regSub(sub_ids.overview.projectOptions.plotSimilarity, sub_ids.overview.projectOptions.plotSimilarity);
regSub(sub_ids.overview.projectOptions.license, sub_ids.overview.projectOptions.license);
regSub(sub_ids.originalProject, sub_ids.originalProject);
regSub(sub_ids.templateProjectName, sub_ids.templateProjectName);

//imagery
regSub(sub_ids.imagery.imageryList, sub_ids.imagery.imageryList);
regSub(sub_ids.imagery.previewId, sub_ids.imagery.imageryId);

// boundary
regSub(sub_ids.boundary.generationMethod, sub_ids.boundary.generationMethod);
regSub(sub_ids.boundary.aoiFeatures, sub_ids.boundary.aoiFeatures);
regSub(sub_ids.boundary.aoiFileName, sub_ids.boundary.aoiFileName);

// plots
regSub(sub_ids.plots.plotDistribution, sub_ids.plots.plotDistribution);
regSub(sub_ids.plots.numPlots, sub_ids.plots.numPlots);
regSub(sub_ids.plots.plotSize, sub_ids.plots.plotSize);
regSub(sub_ids.plots.plotsSource, sub_ids.plots.plotsSource);
regSub(sub_ids.plots.plotShape, sub_ids.plots.plotShape);
regSub(sub_ids.plots.plotSpacing, sub_ids.plots.plotSpacing);
regSub(sub_ids.plots.shufflePlots, sub_ids.plots.shufflePlots);
regSub(sub_ids.plots.totalPlots, sub_ids.plots.totalPlots);
regSub(sub_ids.plots.plotFeatures, sub_ids.plots.plotFeatures);
regSub(sub_ids.plots.plotFileName, sub_ids.plots.plotFileName);
regSub(sub_ids.plots.plotFileBase64, sub_ids.plots.plotFileBase64);
regSub(sub_ids.plots.plotIds, sub_ids.plots.plotIds);
regSub(sub_ids.plots.designSettings, sub_ids.plots.designSettings);
regSub(sub_ids.plots.plotSimilarityDetails, sub_ids.plots.plotSimilarityDetails);
regSub(sub_ids.plots.newPlotDistribution, sub_ids.plots.newPlotDistribution);
regSub(sub_ids.plots.newPlotSize, sub_ids.plots.newPlotSize);
regSub(sub_ids.plots.newPlotShape, sub_ids.plots.newPlotShape);
regSub(sub_ids.plots.newTotalPlots, sub_ids.plots.newTotalPlots);
regSub(sub_ids.plots.newPlotFeatures, sub_ids.plots.newPlotFeatures);
regSub(sub_ids.plots.newPlotFileName, sub_ids.plots.newPlotFileName);
regSub(sub_ids.plots.newPlotFileBase64, sub_ids.plots.newPlotFileBase64);
regSub(sub_ids.plots.maxId, sub_ids.plots.maxId);

// samples
regSub(sub_ids.samples.sampleDistribution, sub_ids.samples.sampleDistribution);
regSub(sub_ids.samples.samplesPerPlot, sub_ids.samples.samplesPerPlot);
regSub(sub_ids.samples.sampleResolution, sub_ids.samples.sampleResolution);
regSub(sub_ids.samples.sampleFileName, sub_ids.samples.sampleFileName);
regSub(sub_ids.samples.allowDrawnSamples, sub_ids.samples.allowDrawnSamples);
regSub(sub_ids.samples.sampleFileBase64, sub_ids.samples.sampleFileBase64);

regSub(sub_ids.questions.questions, sub_ids.questions.questions);

// rules
regSub(sub_ids.rules.rules, sub_ids.rules.rules);
regSub(sub_ids.rules.search, sub_ids.rules.search);
regSub(sub_ids.rules.filter, sub_ids.rules.filter);
regSub(sub_ids.rules.selectedRuleType, sub_ids.rules.selectedRuleType);
regSub(sub_ids.rules.newRule.label, sub_ids.rules.newRule.label);
regSub(sub_ids.rules.newRule.answers, sub_ids.rules.newRule.answers);
regSub(sub_ids.rules.newRule.regex, sub_ids.rules.newRule.regex);
regSub(sub_ids.rules.newRule.min, sub_ids.rules.newRule.min);
regSub(sub_ids.rules.newRule.max, sub_ids.rules.newRule.max);
regSub(sub_ids.rules.newRule.validSum, sub_ids.rules.newRule.validSum);
regSub(sub_ids.rules.newRule.questionId, sub_ids.rules.newRule.questionId);
regSub(sub_ids.rules.newRule.questionIds, sub_ids.rules.newRule.questionIds);
regSub(sub_ids.rules.newRule.questionId1, sub_ids.rules.newRule.questionId1);
regSub(sub_ids.rules.newRule.questionId2, sub_ids.rules.newRule.questionId2);
regSub(sub_ids.rules.newRule.questionIds1, sub_ids.rules.newRule.questionIds1);
regSub(sub_ids.rules.newRule.questionIds2, sub_ids.rules.newRule.questionIds2);
regSub(sub_ids.rules.newRule.answerId1, sub_ids.rules.newRule.answerId1);
regSub(sub_ids.rules.newRule.answerId2, sub_ids.rules.newRule.answerId2);
regSub(sub_ids.rules.newRule.tempQuestionId, sub_ids.rules.newRule.tempQuestionId);
regSub(sub_ids.rules.newRule.tempAnswerId, sub_ids.rules.newRule.tempAnswerId);
regSub(sub_ids.rules.newRule.incompatQuestionId, sub_ids.rules.newRule.incompatQuestionId);
regSub(sub_ids.rules.newRule.incompatAnswerId, sub_ids.rules.newRule.incompatAnswerId);

// institution
regSub(sub_ids.institution.users, sub_ids.institution.users);
regSub(sub_ids.institution.imagery, sub_ids.institution.imagery);
regSub(sub_ids.invalidSteps, sub_ids.invalidSteps);



// EVENTS

regEvent(event_ids.projectId, ({ draftDb }, projectId) => {
  draftDb[sub_ids.projectId] = projectId;
});

regEvent(event_ids.templateProjectName, ({ draftDb }, name) => {
  draftDb[sub_ids.templateProjectName] = name;
});

regEvent(event_ids.templatePlotDesign, ({ draftDb }, clear = false) => {
  draftDb[sub_ids.templatePlotDesign] = clear ? null : pickKeys(current(draftDb), PLOT_DESIGN_KEYS);
});

regEvent(event_ids.projectDetails, ({ draftDb }, projectDetails) => {
  draftDb[sub_ids.projectDetails] = projectDetails;
});

regEvent(event_ids.overview.useTemplatePlots, ({ draftDb }, useTemplatePlots) => {
  draftDb[sub_ids.overview.useTemplatePlots] = useTemplatePlots;
  const snapshot = current(draftDb[sub_ids.templatePlotDesign]);
  if (!snapshot) return;
  Object.assign(draftDb, useTemplatePlots ? snapshot : pickKeys(projectWizardDb, PLOT_DESIGN_KEYS));
});

regEvent(event_ids.errors, ({ draftDb }, errors) => {
  draftDb[sub_ids.errors] = errors;
  draftDb[sub_ids.modal] = 'error';
});

regEvent(event_ids.institutionId, ({ draftDb }, institutionId )=> {
  // URL params arrive as strings; store a number so === comparisons against API ids work.
  draftDb[sub_ids.institutionId] = Number(institutionId);
});
regEvent(event_ids.availability, ({ draftDb }, availability ) => {
  draftDb[sub_ids.availability] = availability;
});
// PROJECT WIZARD EVENTS

regEvent(event_ids.draftProject, ({ draftDb }, draftId) => {
  // Saving again should update this draft, not create a new one.
  draftDb[sub_ids.projectDraftId] = Number(draftId);
  function getProjectDraftById(projectDraftId) {
    fetch(`/get-project-draft-by-id?projectDraftId=${projectDraftId}`)
      .then((response) => (response.ok ? response.json() : Promise.reject(response)))
      .then((data) => {
        if (!data) {
          dispatch([event_ids.errors, [['server', ["No draft found with ID " + projectDraftId + "."]]]]);
          return Promise.resolve();
        } else {
          dispatch([event_ids.templateProject, data]);
          // Imagery isn't part of applyProjectToDb (templates and edits load it separately).
          const imageryIds = data.projectImageryList ?? (data.imageryId > 0 ? [data.imageryId] : []);
          if (imageryIds.length) {
            dispatch([event_ids.imagery.imageryList, imageryIds]);
            dispatch([event_ids.imagery.previewId, imageryIds[0]]);
          }
          return Promise.resolve();
        }
      }).catch(() => {
        dispatch([event_ids.errors, [['server', ["No draft found with ID " + projectDraftId + "."]]]]);
        
      });
  }
  getProjectDraftById(draftId);
  dispatch([event_ids.modal, null]);
  dispatch([event_ids.currentStep, 'review']);
});

regEvent(event_ids.editProject, ({ draftDb }, projectId) => {
  function getProjectById(projectId) {
    fetch(`/get-project-by-id?projectId=${projectId}`)
      .then((response) => (response.ok ? response.json() : Promise.reject(response)))
      .then((data) => {
        if (!data) {
          dispatch([event_ids.errors, [['server', ["Can't edit project  " + projectId + "."]]]]);
          return Promise.resolve();
        } else {
          dispatch([event_ids.templateProject, data]);
          return Promise.resolve();
        }
      }).catch(() => {
        dispatch([event_ids.errors, [['server', ["Can't edit project " + projectId + "."]]]]);
      });
  }
  function getProjectImagery(projectId) {
    fetch(`/get-project-imagery?projectId=${projectId}`)
      .then((response) => (response.ok ? response.json() : Promise.reject(response)))
      .then((data) => {
        if (!data) {
          dispatch([event_ids.errors, [['server', ["Can't edit project" + projectId + "."]]]]);
          return Promise.resolve();
        } else {
          dispatch([event_ids.imagery.imageryList, data.map((i) => i.id)]);
          return Promise.resolve();
        }
      }).catch(() => {
        dispatch([event_ids.errors, [['server', ["Can't edit project " + projectId + "."]]]]);
      });
  }
  getProjectImagery(projectId);
  getProjectById(projectId);
  draftDb[sub_ids.projectId] = projectId;
  dispatch([event_ids.modal, null]);
  dispatch([event_ids.currentStep, 'review']);
});

const plotDesignLocked = (draftDb) =>
  current(draftDb[sub_ids.templateProjectId]) > 0
    && current(draftDb[sub_ids.projectId]) === -1
    && Boolean(current(draftDb[sub_ids.overview.useTemplatePlots]));

export function buildProject (draftDb, sub_ids) {
  const projectId = current(draftDb[sub_ids.projectId]);
  const plotDistribution = current(draftDb[sub_ids.plots.plotDistribution]);
  const originalProject = current(draftDb[sub_ids.originalProject]);
  const useTemplatePlots = current(draftDb[sub_ids.overview.useTemplatePlots]);
  const name = current(draftDb[sub_ids.overview.projectName]);
  const description= current(draftDb[sub_ids.overview.projectDescription]);
  const privacyLevel = current(draftDb[sub_ids.overview.visibility]);
  const imageryId = current(draftDb[sub_ids.imagery.imageryList])[0];
  const aoiFeatures = current(draftDb[sub_ids.boundary.aoiFeatures]);
  const numPlots = current(draftDb[sub_ids.plots.numPlots]);
  const designSettings = current(draftDb[sub_ids.plots.designSettings]);
  const totalPlots = current(draftDb[sub_ids.plots.totalPlots]);
  const allowDrawnSamples = current(draftDb[sub_ids.samples.allowDrawnSamples]);
  const samplesPerPlot = current(draftDb[sub_ids.samples.samplesPerPlot]);
  const plotShape = current(draftDb[sub_ids.plots.plotShape]);
  const sampleDistribution = current(draftDb[sub_ids.samples.sampleDistribution]);
  const sampleFileName = current(draftDb[sub_ids.samples.sampleFileName]);
  const sampleResolution = current(draftDb[sub_ids.samples.sampleResolution]);
  const surveyQuestions = current(draftDb[sub_ids.questions.questions]);
  const plotSize = current(draftDb[sub_ids.plots.plotSize]);
  const projectImageryList = current(draftDb[sub_ids.imagery.imageryList]);
  const aoiFileName = current(draftDb[sub_ids.boundary.aoiFileName]);
  const type = current(draftDb[sub_ids.overview.projectType]);
  const gee = current(draftDb[sub_ids.overview.projectOptions.showGEEScript]);
  const showPlotInformation = current(draftDb[sub_ids.overview.projectOptions.showPlotInformation]);
  const collectConfidence = current(draftDb[sub_ids.overview.projectOptions.collectConfidence]);
  const autoLaunchGeoDash = current(draftDb[sub_ids.overview.projectOptions.autoLaunchGeoDash]);
  const plotSimilarity = current(draftDb[sub_ids.overview.projectOptions.plotSimilarity]);
  const license = current(draftDb[sub_ids.overview.projectOptions.license]);
  const projectOptions = {
    showGEEScript: gee,
    showPlotInformation: showPlotInformation,
    collectConfidence: collectConfidence,
    autoLaunchGeoDash: autoLaunchGeoDash,
    plotSimilarity,
    license,
  };
  const plotSpacing = Number(current(draftDb[sub_ids.plots.plotSpacing]));
  const shufflePlots = current(draftDb[sub_ids.plots.shufflePlots]);
  const surveyRules = current(draftDb[sub_ids.rules.rules]);
  const plotFileName = current(draftDb[sub_ids.plots.plotFileName]);
  const plotFileBase64 = current(draftDb[sub_ids.plots.plotFileBase64]);
  const sampleFileBase64 = current(draftDb[sub_ids.samples.sampleFileBase64]);
  const availability = current(draftDb[sub_ids.availability]);
  const isPublished = availability === 'published';
  const newPlotDistribution = current(draftDb[sub_ids.plots.newPlotDistribution]);
  const newPlotSize = current(draftDb[sub_ids.plots.newPlotSize]);
  const newPlotShape = current(draftDb[sub_ids.plots.newPlotShape]);
  const newTotalPlots = current(draftDb[sub_ids.plots.newTotalPlots]);
  const newPlotFileName = current(draftDb[sub_ids.plots.newPlotFileName]);
  const newPlotFileBase64 = current(draftDb[sub_ids.plots.newPlotFileBase64]);
  const learningMaterial = current(draftDb[sub_ids.overview.learningMaterial]);
  const isEditing = projectId > 0;
  const original = current(draftDb[sub_ids.originalProject]) || {};
  const designChanged = (keys) =>
    !_.isEqual(pickKeys(current(draftDb), keys), pickKeys(original, keys));
  const locked = plotDesignLocked(draftDb);
  const plotFileNeeded = !locked
    && (!isEditing || plotDistribution !== original['plots.plotDistribution']);

  return {
    name,
    description,
    privacyLevel,
    learningMaterial,
    imageryId,
    aoiFeatures,
    plotDistribution,
    numPlots,

    projectImageryList,
    aoiFileName,
    type,
    projectOptions,
    plotSpacing,
    shufflePlots,
    surveyRules,
    plotFileName,
    plotFileBase64,
    sampleFileBase64,
          
    //TODO: are we using these values for validation?
    useTemplatePlots,
    //originalProject: TODO!!!
          
    designSettings,
    totalPlots,
    plotSize,
    plotFileNeeded,
    allowDrawnSamples,
    samplesPerPlot,
    plotShape,
    sampleDistribution,
    sampleFileName,
    sampleResolution,
    skipPlotValidation:   locked || (isEditing && !designChanged(PLOT_DESIGN_FIELDS)),
    skipSampleValidation: locked || (isEditing && !designChanged(SAMPLE_DESIGN_FIELDS)),
    plotLimit: 5000,
    sampleLimit: 35000,
    perPlotLimit: 200,
    ...(isPublished && newPlotFileName && {
      append: true,
      newPlotDistribution,
      newPlotFileName,
      newPlotFileBase64,
      plotShape: newPlotShape,
      plotSize: newPlotSize,
      totalPlots: newTotalPlots,
    }),
    surveyQuestions: Object.entries(surveyQuestions).reduce((acc, [idx, val])=>{
      return {...acc, [idx]: val};
    },{}),
  };
}

regEvent(event_ids.currentStep, ({ draftDb }, currentStep) => {
  const prevStep = draftDb[sub_ids.currentStep];
  if (prevStep && validateStep[prevStep]) {
    const errors = validateStep[prevStep](buildProject(draftDb, sub_ids));
    const invalid = (errors || []).length > 0;
    const list = current(draftDb[sub_ids.invalidSteps]);
    draftDb[sub_ids.invalidSteps] = invalid
      ? [...new Set([...list, prevStep])]
      : list.filter((s) => s !== prevStep);
  }
  draftDb[sub_ids.currentStep] = currentStep;
});

regEvent(event_ids.validate, ({ draftDb }, step='wizard') => {
  const form = buildProject(draftDb, sub_ids);

  switch (step) {
  case 'overview' : {    
    const errors = validateOverview(form).filter((e)=>e);
    errors.length && dispatch([event_ids.errors, [['overview', errors]]]);
    break;}
  case 'imagery': {
    const errors = validateImagery(form).filter((e)=>e);
    errors.length && dispatch([event_ids.errors, [['imagery', errors]]]);
    break;}
  case 'plots' : {
    const errors = validatePlots(form).filter((e)=>e);
    errors.length && dispatch([event_ids.errors, [['plots', errors]]]);
    break;}
  case 'samples' : {
    const errors = validateSamples(form).filter((e)=>e);
    errors.length && dispatch([event_ids.errors, [['samples', errors]]]);
    break;}
  case 'questions' : {
    const errors = validateQuestions(form).filter((e)=>e);
    errors.length && dispatch([event_ids.errors, [['questions', errors]]]);
    break;}
  case 'review' : {
    const errors = validateWizard(form);
    errors && dispatch([event_ids.errors, errors]);
    break;}
  case 'wizard' : {
    const errors = validateWizard(form);
    errors.length ? dispatch([event_ids.errors, errors]) : dispatch([event_ids.currentStep, 'review']);
    !errors.length && dispatch([event_ids.modal, null]);
    break;}
  default : 
    dispatch([event_ids.errors, [['Navigation', ['Your browser experienced a client error. please refresh the page.']]]]);
  }
});

regEvent(event_ids.continueHandler, ({ draftDb }, currentStep) => {
  
  const form = buildProject(draftDb, sub_ids);
  const isSimplified = draftDb[sub_ids.overview.projectType] === 'simplified';

  switch (currentStep) {
  case 'overview' : {    
    const errors = validateOverview(form).filter((e)=>e);
    errors.length ? dispatch([event_ids.errors, [['overview', errors]]]) :
      dispatch([event_ids.currentStep, 'imagery']);
    break;}
  case 'imagery': {
    const errors = validateImagery(form).filter((e)=>e);
    errors.length ? dispatch([event_ids.errors, [['imagery', errors]]]) 
      : dispatch([event_ids.currentStep, 'boundary']) ;
    break;}
  case 'boundary' : {
    dispatch([event_ids.currentStep, isSimplified ? 'questions' : 'plots']);
    break;}
  case 'plots' : {
    const errors = validatePlots(form).filter((e)=>e);
    errors.length ? dispatch([event_ids.errors, [['plots', errors]]]) 
      : dispatch([event_ids.currentStep, 'samples']);
    break;}
  case 'samples' : {
    const errors = validateSamples(form).filter((e)=>e);
    errors.length ? dispatch([event_ids.errors, [['samples', errors]]]) 
      : dispatch([event_ids.currentStep, 'questions']);
    break;}
  case 'questions' : {
    const errors = validateQuestions(form).filter((e)=>e);
    errors.length ? dispatch([event_ids.errors, [['questions', errors]]]) 
      : dispatch([event_ids.currentStep, isSimplified ? 'review' : 'rules']);
    break;}
  case 'rules' : {
    dispatch([event_ids.currentStep, 'review']);
    break;}
  default : 
    dispatch([event_ids.errors, [['Navigation', ['Your browser experienced a client error. please refresh the page.']]]]);    
  }
});

regEvent(event_ids.templateProjectId, ({ draftDb }, templateProjectId) => {
  draftDb[sub_ids.templateProjectId] = templateProjectId;
});

regEvent(event_ids.overview.useTemplateWidgets, ({ draftDb }, useTemplateWidgets) => {
  draftDb[sub_ids.overview.useTemplateWidgets] = useTemplateWidgets;
});

function applyProjectToDb (draftDb, {
  allowDrawnSamples,
  aoiFeatures,
  aoiFileName,
  description,
  designSettings = {},
  learningMaterial = '',
  name,
  numPlots = 0,
  plotDistribution,
  plotFileName,
  plotShape,
  plotSize,
  plotSpacing = -1,
  projectOptions = {showGEEScript : false, showPlotInformation: false, collectConfidence: false, autoLaunchGeoDash: false},
  type,
  referencePlot = -1,
  sampleDistribution,
  sampleFileName,
  sampleResolution,
  samplesPerPlot,
  surveyQuestions,
  surveyRules = [],
  availability = '',
  createdDate = '',
  publishedDate = '',
  closedDate = '',
  privacyLevel,

}) {
  draftDb[sub_ids.overview.projectName] = name;
  draftDb[sub_ids.overview.projectDescription] = description;
  draftDb[sub_ids.overview.projectType] = type;
  draftDb[sub_ids.overview.learningMaterial] = learningMaterial;
  draftDb[sub_ids.overview.visibility] = privacyLevel ?? draftDb[sub_ids.overview.visibility];
  draftDb[sub_ids.overview.projectOptions.showGEEScript] = projectOptions.showGEEScript;
  draftDb[sub_ids.overview.projectOptions.showPlotInformation] = projectOptions.showPlotInformation;
  draftDb[sub_ids.overview.projectOptions.collectConfidence] = projectOptions.collectConfidence;
  draftDb[sub_ids.overview.projectOptions.autoLaunchGeoDash] = projectOptions.autoLaunchGeoDash;
  draftDb[sub_ids.overview.projectOptions.plotSimilarity] = projectOptions.plotSimilarity ?? false;
  draftDb[sub_ids.overview.projectOptions.license] = projectOptions.license ?? null;
  draftDb[sub_ids.boundary.generationMethod] =
  ['shp', 'geojson', 'csv'].includes(plotDistribution) ? 'plotFile' : 'manual';
  draftDb[sub_ids.boundary.aoiFeatures] = aoiFeatures;
  draftDb[sub_ids.boundary.aoiFileName] = aoiFileName;
  draftDb[sub_ids.plots.plotDistribution] = plotDistribution;
  draftDb[sub_ids.plots.numPlots] = Number(numPlots);
  draftDb[sub_ids.plots.plotSize] = Number(plotSize);
  draftDb[sub_ids.plots.plotShape] = plotShape;
  draftDb[sub_ids.plots.plotSpacing] = plotSpacing;
  draftDb[sub_ids.plots.totalPlots] = Number(numPlots);
  draftDb[sub_ids.plots.plotFileName] = plotFileName;
  draftDb[sub_ids.plots.referencePlotId] = Number(referencePlot);
  draftDb[sub_ids.plots.designSettings] = designSettings;
  draftDb[sub_ids.samples.sampleDistribution] = sampleDistribution;
  draftDb[sub_ids.samples.samplesPerPlot] = Number((samplesPerPlot));
  draftDb[sub_ids.samples.sampleResolution] = Number(sampleResolution);
  draftDb[sub_ids.samples.sampleFileName] = sampleFileName;
  draftDb[sub_ids.samples.allowDrawnSamples] = allowDrawnSamples;
  draftDb[sub_ids.questions.questions] = surveyQuestions;
  draftDb[sub_ids.rules.rules] = surveyRules;
  draftDb[sub_ids.availability] = availability;
  draftDb[sub_ids.createdDate] = createdDate;
  draftDb[sub_ids.publishedDate] = publishedDate;
  draftDb[sub_ids.closedDate] = closedDate;
  draftDb[sub_ids.originalProject] =
    pickKeys(current(draftDb), [...PLOT_DESIGN_FIELDS, ...SAMPLE_DESIGN_FIELDS, LICENSE_KEY]);
}

regEvent(event_ids.templateProject, ({ draftDb }, project) => {
  applyProjectToDb(draftDb, project);
});

// PLOT FILE HELPERS (shared by PlotStep uploads and the Collect Earth import)

const PLOT_ID_KEYS = ['visible_id', 'plotid', 'plot_id', 'PlotID', 'plotId', 'PLOTID'];

// Extracts visible ids from /check-plot-file plots.
export const extractPlotIds = (plots) =>
  plots
    .map((plot) => {
      const props = plot.properties || plot;
      const idKey = Object.keys(props).find((key) => PLOT_ID_KEYS.includes(key));
      return idKey ? props[idKey] : undefined;
    })
    .filter((id) => id != null);

// Extracts geometries from /check-plot-file plots.
export const extractPlotGeometries = (plots) =>
  plots
    .map((plot) => (plot ? (plot.type ? plot : plot.plot_geom || plot.plotGeom) : null))
    .filter(Boolean);

// IMPORT COLLECT EARTH PROJECT
// The CE import response omits fields that templates/drafts always carry, so fill
// wizard defaults first, apply it like a template, then set what templateProject doesn't.
const withDesignDefaults = (designSettings = {}) => {
  const defaults = _.cloneDeep(projectWizardDb['plots.designSettings']);
  return {
    ...defaults,
    ...designSettings,
    sampleGeometries: { ...defaults.sampleGeometries, ...designSettings.sampleGeometries },
    userAssignment:   { ...defaults.userAssignment,   ...designSettings.userAssignment },
    qaqcAssignment:   { ...defaults.qaqcAssignment,   ...designSettings.qaqcAssignment },
  };
};

const withImportDefaults = (project) => ({
  ...project,
  type:               project.type ?? 'regular',
  designSettings:     withDesignDefaults(project.designSettings),
  allowDrawnSamples:  project.allowDrawnSamples ?? false,
  plotShape:          project.plotShape ?? projectWizardDb['plots.plotShape'],
  plotSize:           project.plotSize ?? 0,
  sampleDistribution: project.sampleDistribution ?? 'center',
  samplesPerPlot:     project.samplesPerPlot ?? 1,
  sampleResolution:   project.sampleResolution ?? 0,
  sampleFileName:     project.sampleFileName ?? '',
  surveyQuestions:    project.surveyQuestions ?? {},
});

// Same parsing path as a user upload in PlotStep: the server reads the file,
// the preview shows the geometries it returns.
const IMPORT_PLOT_FILE_TYPES = ['csv', 'shp', 'geojson'];

const previewImportedPlotFile = (plotFileType, plotFileName, plotFileBase64) =>
  fetch('/check-plot-file', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ plotFileType, projectId: 0, plotFileName, plotFileBase64 }),
  })
    .then((res) => (res.ok ? res.json() : Promise.reject(res)))
    .then((data) => {
      const plots = data.plots || [];
      dispatch([event_ids.plots.totalPlots, plots.length]);
      dispatch([event_ids.plots.plotFeatures, extractPlotGeometries(plots)]);
      dispatch([event_ids.plots.plotIds, extractPlotIds(plots)]);
    })
    .catch((err) => {
      console.error(err);
      dispatch([event_ids.errors, [['File Error', ['Failed to parse imported plot file']]]]);
    });

const defaultBasemapId = (institutionImagery = []) =>
  (institutionImagery.find(({ visibility }) => visibility === 'platform') ?? institutionImagery[0])?.id;

regEvent(event_ids.importProject, ({ draftDb }, project) => {
  const imported = withImportDefaults(project);
  applyProjectToDb(draftDb, imported);

  // Not mapped by templateProject
  draftDb[sub_ids.plots.plotFileBase64] = imported.plotFileBase64 ?? null;
  draftDb[sub_ids.samples.sampleFileBase64] = imported.sampleFileBase64 ?? null;
  draftDb[sub_ids.plots.plotFeatures] = [];
  draftDb[sub_ids.plots.plotIds] = [];
  if (IMPORT_PLOT_FILE_TYPES.includes(imported.plotDistribution) && imported.plotFileBase64) {
    previewImportedPlotFile(imported.plotDistribution, imported.plotFileName, imported.plotFileBase64);
  }

  // CE files carry no CEO imagery, so fall back to the institution's first platform basemap
  const basemapId = defaultBasemapId(current(draftDb[sub_ids.institution.imagery]));
  if (basemapId != null && !current(draftDb[sub_ids.imagery.imageryList]).length) {
    draftDb[sub_ids.imagery.imageryList] = [basemapId];
    draftDb[sub_ids.imagery.previewId] = basemapId;
  }

  // Flag steps that still need attention in the navigator, without opening the error modal
  const errors = validateWizard(buildProject(draftDb, sub_ids));
  draftDb[sub_ids.invalidSteps] = errors ? errors.map(([step]) => step) : [];
});

regEvent(event_ids.draftSaving, ({ draftDb }, saving) => {
  draftDb[sub_ids.draftSaving] = saving;
});

regEvent(event_ids.saveDraft, ({ draftDb }) => {
  // The draft id only exists once the create request returns, so ignore clicks while a
  // save is in flight; otherwise each click would create another draft.
  if (current(draftDb[sub_ids.draftSaving])) return;

  const institutionId = Number(current(draftDb[sub_ids.institutionId]));
  const form = buildProject(draftDb, sub_ids);
  const useTemplateWidgets = current(draftDb[sub_ids.overview.useTemplateWidgets]);
  const useTemplatePlots = current(draftDb[sub_ids.overview.useTemplatePlots]);
  const templateProjectId = current(draftDb[sub_ids.templateProjectId]);
  const projectDraftId = current(draftDb[sub_ids.projectDraftId]);

  // Validation failures come back as {params: {field: message}}; other failures as a string.
  const draftErrors = (message) =>
    message?.params
      ? Object.entries(message.params).map(([field, error]) => field + ": " + error)
      : [typeof message === 'string' ? message : 'Error saving draft. See console for details.'];

  function createProjectDraft () {
    fetch("/create-project-draft", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify({
        institutionId ,
        projectTemplate: templateProjectId,
        useTemplatePlots ,
        useTemplateWidgets,
        ...form,
      }),
    })
      .then((response) => Promise.all([response.ok, response.json()]))
      .then((data) => {
        if (data[0] && Number.isInteger(data[1].projectDraftId)) {
          dispatch([event_ids.draftSuccess, ['Draft Saved', data[1]]]);          
          return Promise.resolve();
        } else {          
          return Promise.reject(data[1]);
        }
      })
      .catch((message) => {
        console.log('create project draft errors', message);
        dispatch([event_ids.errors, [['server', draftErrors(message)]]]);
      })
      .finally(() => dispatch([event_ids.draftSaving, false]));
  }

  function saveProjectDraft () {
    fetch("/update-project-draft", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify({
        projectDraftId,
        institutionId,
        projectTemplate: templateProjectId,
        useTemplatePlots ,
        useTemplateWidgets ,
        ...form,
      }),
    })
      .then((response) => Promise.all([response.ok, response.json()]))
      .then((data) => {
        if (!data[0]) return Promise.reject(data[1]);
        dispatch([event_ids.draftSuccess, ['Draft Saved', data[1]]]);
        return Promise.resolve();
      })
      .catch((message) => {
        console.log('update project draft errors', message);
        dispatch([event_ids.errors, [['server', draftErrors(message)]]]);
      })
      .finally(() => dispatch([event_ids.draftSaving, false]));
  }

  draftDb[sub_ids.draftSaving] = true;
  projectDraftId > 0
    ? saveProjectDraft()
    : createProjectDraft();
});


regEvent(event_ids.projectSaving, ({ draftDb }, saving) => {
  draftDb[sub_ids.projectSaving] = saving;
});

regEvent(event_ids.saveProject, ({ draftDb }, acceptTos, overwrite) => {
  // Ignore repeat clicks while a create/update request is in flight; concurrent updates
  // can each delete and regenerate the plots and leave duplicates behind.
  if (current(draftDb[sub_ids.projectSaving])) return;

  const institutionId = Number(current(draftDb[sub_ids.institutionId]));
  const useTemplateWidgets = current(draftDb[sub_ids.overview.useTemplateWidgets]);
  const useTemplatePlots = current(draftDb[sub_ids.overview.useTemplatePlots]);
  const templateProjectId = current(draftDb[sub_ids.templateProjectId]);
  const similarityDetails = current(draftDb[sub_ids.plots.plotSimilarityDetails]) || {};
  const existingProjectId = current(draftDb[sub_ids.projectId]);
  const referencePlotId = similarityDetails.referencePlotId;
  const similarityYears = similarityDetails.years;
  const form = buildProject(draftDb, sub_ids);
  const errors = validateWizard(form);
  
  function updateProject () {
    fetch("/update-project", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify({
        projectId: existingProjectId,
        overwrite: overwrite === true,
        ...form,
      }),
    })
      .then((response) => Promise.all([response.ok, response.json()]))
      .then((data) => {
        if (data[0]) {
          window.location.assign(`/project-wizard?projectId=${existingProjectId}&institutionId=${institutionId}`);
          return Promise.resolve();
        } else {
          dispatch([event_ids.errors, [['server', Object.entries(data[1].params).map(([field, error]) => field + ": " + error)]]]);
          return Promise.reject(data[1]);
        }
      })
      .catch((message) => {
        // A successful update redirects, so only failures re-enable the buttons.
        dispatch([event_ids.projectSaving, false]);
        dispatch([event_ids.errors, [['server', [message]]]]);;
      });
  }
  
  function createProject () {
    fetch("/create-project", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify({
        institutionId,
        projectTemplate: templateProjectId,
        useTemplatePlots,
        useTemplateWidgets,
        acceptTos: typeof acceptTos === "string" ? acceptTos : "",
        ...form,
      }),
    })
      .then((response) => Promise.all([response.ok, response.json()]))
      .then((data) => {
        if (data[0] && Number.isInteger(data[1].projectId)) {
          const projectId = data[1].projectId;
          const goToWizard = () =>
            window.location.assign(`/project-wizard?projectId=${projectId}&institutionId=${institutionId}`);
          if (referencePlotId > 0) {
            return fetch("/start-plot-similarity", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json; charset=utf-8",
              },
              body: JSON.stringify({ projectId, referencePlotId, similarityYears }),
            })
              .catch((err) => console.error("start-plot-similarity failed", err))
              .finally(goToWizard);
          }

          goToWizard();
          return Promise.resolve();
        } else {
          dispatch([event_ids.errors, [['server',
            Object.entries(data[1].params).map(([field, error]) => field + ": " + error)]]]);
          return Promise.reject(data[1]);
        }
      })
      .catch((message) => {
        dispatch([event_ids.projectSaving, false]);
        dispatch([event_ids.errors, [['server', [message]]]]);
      });
  }

  if (errors) {
    dispatch([event_ids.errors, errors]);
    return;
  }
  draftDb[sub_ids.projectSaving] = true;
  (existingProjectId > 0) ? updateProject() : createProject();
});

regEvent(event_ids.publishProject, ({ draftDb }) => {
  const availability = draftDb[sub_ids.availability];
  const unpublished = availability === "unpublished";
  const projectId = draftDb[sub_ids.projectId];

  fetch(`/publish-project?projectId=${projectId}&clearSaved=${unpublished}`, { method: "POST" })
    .then((response) => (response.ok ? response.json() : Promise.reject(response)))
    .then((data) => {dispatch([event_ids.modal, 'published']);})
    .catch((error) => {
      console.log(error);
      window.alert("Error publishing project. See console for details.");
    });
});

regEvent(event_ids.draftSuccess, ({ draftDb }, response) => {
  // Remember a newly created draft so the next save updates it instead of creating another.
  const createdDraftId = response?.[1]?.projectDraftId;
  if (Number.isInteger(createdDraftId)) draftDb[sub_ids.projectDraftId] = createdDraftId;
  draftDb[sub_ids.successResponse] = response;
  draftDb[sub_ids.modal] = 'draft-success';
});

regEvent(event_ids.successResponse, ({ draftDb }, response) => {  
  draftDb[sub_ids.successResponse] = response;
  draftDb[sub_ids.modal] = 'success';
});

regEvent(event_ids.modal, ({ draftDb }, modal, errors) => {
  errors && dispatch([event_ids.validate]);
  draftDb[sub_ids.modal] = modal;
});

regEvent(event_ids.overview.projectType, ({ draftDb }, projectType) => {
  draftDb[sub_ids.overview.projectType] = projectType;
});

regEvent(event_ids.projectSource, ({ draftDb }, projectSource) => {
  draftDb[sub_ids.projectSource] = projectSource;
});

// PROJECT OVERVIEW EVENTS

regEvent(event_ids.overview.projectName, ({ draftDb }, projectName) => {
  draftDb[sub_ids.overview.projectName] = projectName;
});

regEvent(event_ids.overview.projectDescription, ({ draftDb }, projectDescription) => {
  draftDb[sub_ids.overview.projectDescription] = projectDescription;
});

regEvent(event_ids.overview.learningMaterial, ({ draftDb }, learningMaterial) => {
  draftDb[sub_ids.overview.learningMaterial] = learningMaterial;
});

regEvent(event_ids.overview.visibility, ({ draftDb }, visibility) => {
  draftDb[sub_ids.overview.visibility] = visibility;
});

regEvent(event_ids.overview.projectOptions.showGEEScript, ({ draftDb }) => {
  draftDb[sub_ids.overview.projectOptions.showGEEScript] = !draftDb[sub_ids.overview.projectOptions.showGEEScript];
});

regEvent(event_ids.overview.projectOptions.showPlotInformation, ({ draftDb }) => {
  draftDb[sub_ids.overview.projectOptions.showPlotInformation] = !draftDb[sub_ids.overview.projectOptions.showPlotInformation];
});

regEvent(event_ids.overview.projectOptions.collectConfidence, ({ draftDb }) => {
  draftDb[sub_ids.overview.projectOptions.collectConfidence] = !draftDb[sub_ids.overview.projectOptions.collectConfidence];
});

regEvent(event_ids.overview.projectOptions.autoLaunchGeoDash, ({ draftDb }) => {
  draftDb[sub_ids.overview.projectOptions.autoLaunchGeoDash] = !draftDb[sub_ids.overview.projectOptions.autoLaunchGeoDash];
});

regEvent(event_ids.overview.projectOptions.plotSimilarity, ({ draftDb }) => {
  draftDb[sub_ids.overview.projectOptions.plotSimilarity] = !draftDb[sub_ids.overview.projectOptions.plotSimilarity];
});

regEvent(event_ids.overview.projectOptions.license, ({ draftDb }, license) => {
  draftDb[sub_ids.overview.projectOptions.license] = license;
});

regEvent(event_ids.imagery.imageryList, ({ draftDb }, imageryList ) => {
  draftDb[sub_ids.imagery.imageryList] = imageryList;
});

regEvent(event_ids.imagery.previewId, ({ draftDb }, previewId) => {
  draftDb[sub_ids.imagery.previewId] = previewId;
});

regEvent(event_ids.questions.addQuestion, ({ draftDb }, nextId, questionToAdd ) => {
  const questions = draftDb[sub_ids.questions.questions];
  draftDb[sub_ids.questions.questions] = {... questions, [nextId]: questionToAdd};
});

// PROJECT BOUNDARY EVENTS

regEvent(event_ids.boundary.generationMethod, ({ draftDb }, method) => {
  draftDb[sub_ids.boundary.generationMethod] = method;
});

regEvent(event_ids.boundary.aoiFeatures, ({ draftDb }, features) => {
  draftDb[sub_ids.boundary.aoiFeatures] = features;
});

regEvent(event_ids.boundary.setBoundaryFromFile, ({ draftDb }, fileName, geometries) => {
  draftDb[sub_ids.boundary.generationMethod] = 'shpFile';
  draftDb[sub_ids.boundary.aoiFileName] = fileName;
  draftDb[sub_ids.boundary.aoiFeatures] = geometries;
});

regEvent(event_ids.boundary.clearBoundary, ({ draftDb }) => {
  draftDb[sub_ids.boundary.aoiFeatures] = [];
  draftDb[sub_ids.boundary.aoiFileName] = '';
});

// PLOT GENERATION EVENTS
regEvent(event_ids.plots.plotDistribution, ({ draftDb }, distribution) => {
  if (draftDb[sub_ids.plots.plotDistribution] === distribution) return;
  draftDb[sub_ids.plots.plotDistribution] = distribution;
  draftDb[sub_ids.plots.plotFeatures] = [];
  draftDb[sub_ids.plots.plotFileName] = '';
  draftDb[sub_ids.plots.plotIds] = [];
  draftDb[sub_ids.plots.totalPlots] = 0;
  draftDb[sub_ids.plots.plotsSource] = 'generated';
});

regEvent(event_ids.plots.numPlots, ({ draftDb }, count) => {
  draftDb[sub_ids.plots.numPlots] = count;
  draftDb[sub_ids.plots.totalPlots] = count;
  draftDb[sub_ids.plots.plotsSource] = 'generated';
});

regEvent(event_ids.plots.plotSize, ({ draftDb }, size) => {
  draftDb[sub_ids.plots.plotSize] = size;
});

regEvent(event_ids.plots.plotShape, ({ draftDb }, shape) => {
  draftDb[sub_ids.plots.plotShape] = shape;
});

regEvent(event_ids.plots.plotSpacing, ({ draftDb }, spacing) => {
  draftDb[sub_ids.plots.plotSpacing] = spacing;
});

regEvent(event_ids.plots.shufflePlots, ({ draftDb }, shouldShuffle) => {
  draftDb[sub_ids.plots.shufflePlots] = shouldShuffle;
});

regEvent(event_ids.plots.totalPlots, ({ draftDb }, total) => {
  draftDb[sub_ids.plots.totalPlots] = total;
});

regEvent(event_ids.plots.plotFeatures, ({ draftDb }, features) => {
  draftDb[sub_ids.plots.plotFeatures] = features;
});

regEvent(event_ids.plots.plotFileName, ({ draftDb }, plotFileName) => {
  draftDb[sub_ids.plots.plotFileName] = plotFileName;
});

regEvent(event_ids.plots.serverPlots, ({ draftDb }, { features, count, maxId }) => {
  draftDb[sub_ids.plots.plotFeatures] = features;
  draftDb[sub_ids.plots.totalPlots] = count;
  draftDb[sub_ids.plots.plotsSource] = 'server';
  draftDb[sub_ids.plots.maxId] = maxId;
});

regEvent(event_ids.plots.plotIds, ({ draftDb }, plotIds) => {
  draftDb[sub_ids.plots.plotIds] = plotIds;
});

regEvent(event_ids.plots.plotFileBase64, ({ draftDb }, plotFileBase64) => {
  draftDb[sub_ids.plots.plotFileBase64] = plotFileBase64;
});

regEvent(event_ids.plots.designSettings, ({ draftDb }, designSettings) => {
  draftDb[sub_ids.plots.designSettings] = designSettings;
});

regEvent(event_ids.plots.plotSimilarityDetails, ({ draftDb }, details) => {
  draftDb[sub_ids.plots.plotSimilarityDetails] = details;
});

// NEW PLOT GENERATION EVENTS (post-publish append)
regEvent(event_ids.plots.newPlotDistribution, ({ draftDb }, distribution) => {
  if (draftDb[sub_ids.plots.newPlotDistribution] === distribution) return;
  draftDb[sub_ids.plots.newPlotDistribution] = distribution;
  draftDb[sub_ids.plots.newPlotFeatures] = [];
  draftDb[sub_ids.plots.newPlotFileName] = '';
  draftDb[sub_ids.plots.newPlotFileBase64] = '';
  draftDb[sub_ids.plots.newTotalPlots] = 0;
});

regEvent(event_ids.plots.newPlotSize, ({ draftDb }, size) => {
  draftDb[sub_ids.plots.newPlotSize] = size;
});

regEvent(event_ids.plots.newPlotShape, ({ draftDb }, shape) => {
  draftDb[sub_ids.plots.newPlotShape] = shape;
});

regEvent(event_ids.plots.newTotalPlots, ({ draftDb }, total) => {
  draftDb[sub_ids.plots.newTotalPlots] = total;
});

regEvent(event_ids.plots.newPlotFeatures, ({ draftDb }, features) => {
  draftDb[sub_ids.plots.newPlotFeatures] = features;
});

regEvent(event_ids.plots.newPlotFileName, ({ draftDb }, fileName) => {
  draftDb[sub_ids.plots.newPlotFileName] = fileName;
});

regEvent(event_ids.plots.newPlotFileBase64, ({ draftDb }, base64) => {
  draftDb[sub_ids.plots.newPlotFileBase64] = base64;
});

// SAMPLE GENERATION EVENTS
regEvent(event_ids.samples.sampleDistribution, ({ draftDb }, distribution) => {
  draftDb[sub_ids.samples.sampleDistribution] = distribution;
});

regEvent(event_ids.samples.samplesPerPlot, ({ draftDb }, count) => {
  draftDb[sub_ids.samples.samplesPerPlot] = count;
});

regEvent(event_ids.samples.sampleResolution, ({ draftDb }, resolution) => {
  draftDb[sub_ids.samples.sampleResolution] = resolution;
});

regEvent(event_ids.samples.sampleFileName, ({ draftDb }, fileName) => {
  draftDb[sub_ids.samples.sampleFileName] = fileName;
});

regEvent(event_ids.samples.sampleFileBase64, ({ draftDb }, fileBase64) => {
  draftDb[sub_ids.samples.sampleFileBase64] = fileBase64;
});


regEvent(event_ids.samples.allowDrawnSamples, ({ draftDb }, allow) => {
  draftDb[sub_ids.samples.allowDrawnSamples] = allow;
});


regEvent(event_ids.questions.setQuestions, ({ draftDb }, questions ) => {
  draftDb[sub_ids.questions.questions] = questions;
});

regEvent(event_ids.questions.updateQuestion, ({ draftDb }, qId, field, value) => {
  const questions = current(draftDb['questions']);
  draftDb['questions'] = { ...questions, [qId]: { ...questions[qId], [field]: value } };
});

regEvent(event_ids.questions.updateAnswer, ({ draftDb }, qId, aId, field, value) => {
  const questions = current(draftDb['questions']);
  const q = questions[qId];
  draftDb['questions'] = {
    ...questions,
    [qId]: { ...q, answers: { ...q.answers, [aId]: { ...q.answers[aId], [field]: value } } },
  };
});

regEvent(event_ids.questions.moveQuestion, ({ draftDb }, id, targetQ, nextId, nextQ) => {
  const questions = draftDb[sub_ids.questions.questions];
  const currentQ = questions[id] || questions[String(id)] || questions[Number(id)];
  const targetNextQ = questions[nextId] || questions[String(nextId)] || questions[Number(nextId)];

  if (currentQ) currentQ.cardOrder = nextQ.cardOrder;
  if (targetNextQ) targetNextQ.cardOrder = targetQ.cardOrder;
});

regEvent(event_ids.questions.removeQuestion, ({ draftDb }, qId, cascadeDelete) => {
  const next = cascadeDelete(
    { questions: current(draftDb['questions']), rules: current(draftDb['rules']) }, qId);
  draftDb['questions'] = next.questions;
  draftDb['rules'] = next.rules;
});

regEvent(event_ids.questions.moveQuestion, ({ draftDb }, id, direction) => {
  draftDb['questions'] = moveQuestion(current(draftDb['questions']), id, direction);
});

// RULES EVENTS


function resetNewRule (draftDb) {
  Object.entries(_.cloneDeep(newRuleDefaults)).forEach(([key, value]) => {
    draftDb[key] = value;
  });
}

regEvent(event_ids.rules.newRule.reset, ({ draftDb }) => {
  resetNewRule(draftDb);
});

regEvent(event_ids.rules.selectedRuleType, ({ draftDb }, selectedRuleType) => {
  draftDb[sub_ids.rules.selectedRuleType] = selectedRuleType;
  resetNewRule(draftDb);
});

regEvent(event_ids.rules.rules, ({ draftDb }, newRule) => {
  draftDb[sub_ids.rules.rules].push({...newRule, label: draftDb[sub_ids.rules.newRule.label]});
  resetNewRule(draftDb);
});

regEvent(event_ids.rules.removeRule, ({ draftDb }, rid ) => {
  const newRules = draftDb[sub_ids.rules.rules].filter((r) => r.id !== rid);
  draftDb[sub_ids.rules.rules] = newRules;
});

regEvent(event_ids.rules.newRule.label, ({ draftDb }, label) => {
  draftDb[sub_ids.rules.newRule.label] = label;
});

regEvent(event_ids.rules.newRule.regex, ({ draftDb }, regex) => {
  draftDb[sub_ids.rules.newRule.regex] = regex;
});

regEvent(event_ids.rules.newRule.questionId, ({ draftDb }, questionId) => {
  draftDb[sub_ids.rules.newRule.questionId] = questionId;
});

regEvent(event_ids.rules.search, ({ draftDb }, search) => {
  draftDb[sub_ids.rules.search] = search;
});

regEvent(event_ids.rules.filter, ({ draftDb }, filter) => {
  draftDb[sub_ids.rules.filter] = filter;
});

regEvent(event_ids.rules.newRule.min, ({ draftDb }, min) => {
  draftDb[sub_ids.rules.newRule.min] = min;
});

regEvent(event_ids.rules.newRule.max, ({ draftDb }, max) => {
  draftDb[sub_ids.rules.newRule.max] = max;
});

regEvent(event_ids.rules.newRule.validSum, ({ draftDb }, validSum) => {
  draftDb[sub_ids.rules.newRule.validSum] = validSum;
});

regEvent(event_ids.rules.newRule.questionIds, ({ draftDb }, questionIds) => {
  draftDb[sub_ids.rules.newRule.questionIds] = questionIds;
});

regEvent(event_ids.rules.newRule.questionIds1, ({ draftDb }, questionIds1) => {
  draftDb[sub_ids.rules.newRule.questionIds1] = questionIds1;
});

regEvent(event_ids.rules.newRule.questionIds2, ({ draftDb }, questionIds2) => {
  draftDb[sub_ids.rules.newRule.questionIds2] = questionIds2;
});

regEvent(event_ids.rules.newRule.questionId1, ({ draftDb }, questionId1) => {
  draftDb[sub_ids.rules.newRule.questionId1] = questionId1;
});

regEvent(event_ids.rules.newRule.questionId2, ({ draftDb }, questionId2) => {
  draftDb[sub_ids.rules.newRule.questionId2] = questionId2;
});

regEvent(event_ids.rules.newRule.answerId1, ({ draftDb }, answerId1) => {
  draftDb[sub_ids.rules.newRule.answerId1] = answerId1;
});

regEvent(event_ids.rules.newRule.answerId2, ({ draftDb }, answerId2) => {
  draftDb[sub_ids.rules.newRule.answerId2] = answerId2;
});

regEvent(event_ids.rules.newRule.answers, ({ draftDb }, answers) => {
  draftDb[sub_ids.rules.newRule.answers] = answers;
});

regEvent(event_ids.rules.newRule.addAnswer, ({ draftDb }) => {
  let dbAnswers = current(draftDb[sub_ids.rules.newRule.answers]);
  let answer = [current(draftDb[sub_ids.rules.newRule.tempQuestionId]),
    current(draftDb[sub_ids.rules.newRule.tempAnswerId])];
  draftDb[sub_ids.rules.newRule.answers] = [... dbAnswers, answer];
});
regEvent(event_ids.rules.newRule.removeAnswer, ({ draftDb }, questionId) => {
  let dbAnswers = current(draftDb[sub_ids.rules.newRule.answers]);
  draftDb[sub_ids.rules.newRule.answers] = dbAnswers.filter(([question])=>question != questionId);
});

regEvent(event_ids.rules.newRule.tempQuestionId, ({ draftDb }, tempQuestionId) => {
  draftDb[sub_ids.rules.newRule.tempQuestionId] = tempQuestionId;
});

regEvent(event_ids.rules.newRule.tempAnswerId, ({ draftDb }, tempAnswerId) => {
  draftDb[sub_ids.rules.newRule.tempAnswerId] = tempAnswerId;
});

regEvent(event_ids.rules.newRule.incompatQuestionId, ({ draftDb }, incompatQuestionId) => {
  draftDb[sub_ids.rules.newRule.incompatQuestionId] = incompatQuestionId;
});

regEvent(event_ids.rules.newRule.incompatAnswerId, ({ draftDb }, incompatAnswerId) => {
  draftDb[sub_ids.rules.newRule.incompatAnswerId] = incompatAnswerId;
});

regEvent(event_ids.rules.removeRule, ({ draftDb }, rid) => {
  draftDb[sub_ids.rules.rules] =
    renumberRules(current(draftDb[sub_ids.rules.rules]).filter((r) => r.id !== rid));
});


// EVENTS FOR INSTITUTION INFORMATION
regEvent(event_ids.institution.users, ({draftDb}, users) => {
  draftDb[sub_ids.institution.users] = users;
});

regEvent(event_ids.institution.imagery, ({ draftDb }, imagery) => {
  draftDb[sub_ids.institution.imagery] = imagery;
});

export const usePlotDesignLocked = () => {
  const templateProjectId = useSubscription([sub_ids.templateProjectId]) || -1;
  const projectId = useSubscription([sub_ids.projectId]) || -1;
  const useTemplatePlots = useSubscription([sub_ids.overview.useTemplatePlots]);
  return templateProjectId > 0 && projectId === -1 && Boolean(useTemplatePlots);
};

// Once published, a project's data license can go from private to public but never back.
// True when the project was published (or closed) with a saved public license, which
// means the private option must be disabled. Unsaved changes in this session don't count.
export const usePublicLicenseLocked = () => {
  const projectId = useSubscription([sub_ids.projectId]) || -1;
  const availability = useSubscription([sub_ids.availability]);
  const originalProject = useSubscription([sub_ids.originalProject]) || {};
  return projectId > 0
    && ['published', 'closed'].includes(availability)
    && originalProject[LICENSE_KEY] === 'public';
};

export const renumberRules = (rules) => rules.map((rule, i) => ({ ...rule, id: i }));

const LICENSE_KEY = 'overview.projectOptions.license';

const PLOT_DESIGN_FIELDS = [
  'boundary.generationMethod', 'boundary.aoiFeatures', 'boundary.aoiFileName',
  'plots.plotDistribution', 'plots.numPlots', 'plots.plotSize', 'plots.plotShape',
  'plots.plotSpacing', 'plots.shufflePlots', 'plots.plotFileName', 'plots.plotFileBase64',
  'plots.designSettings',
  // append mode on published projects
  'plots.newPlotDistribution', 'plots.newPlotFileName', 'plots.newPlotFileBase64',
  'plots.newPlotSize', 'plots.newPlotShape',
];
const SAMPLE_DESIGN_FIELDS = [
  'samples.sampleDistribution', 'samples.samplesPerPlot', 'samples.sampleResolution',
  'samples.sampleFileName', 'samples.sampleFileBase64', 'samples.allowDrawnSamples',
];
const DERIVED_DESIGN_KEYS = ['plots.plotsSource', 'plots.totalPlots', 'plots.plotFeatures', 'plots.plotIds',
  'plots.maxId', 'plots.referencePlotId', 'plots.plotSimilarityDetails'];
const PLOT_DESIGN_KEYS = [...PLOT_DESIGN_FIELDS, ...SAMPLE_DESIGN_FIELDS, ...DERIVED_DESIGN_KEYS];

const pickKeys = (source, keys) => Object.fromEntries(keys.map((k) => [k, source[k]]));
